var url = 'http://backend.aiyihuo.com/' // 威海
// var url = 'http://rzbackend.aiyihuo.com/' // 日照
// var url = 'http://rcbackend.aiyihuo.com/' // 荣成
// var url = 'http://rsbackend.aiyihuo.com/' // 乳山
// var url = 'http://wdbackend.aiyihuo.com/' // 文登
// var url = 'http://hyjbackend.aiyihuo.com/' // 好运角
// var url = 'http://gaoqubackend.aiyihuo.com/' // 高区
// var url = '/api'
export default url



// WEBPACK FOOTER //
// ./src/common/common.js